import React from 'react'
import checkbookIcon from '../../assets/icons/checkbook.png'

const CheckboxIcon = ({ size = 24, style = {} }) => {
  return (
    <img 
      src={checkbookIcon} 
      alt="Checkbox" 
      width={size} 
      height={size}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style 
      }}
    />
  )
}

export default CheckboxIcon
